import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CmNumericValidatorVariation } from './numeric-validator-variants.enum';


export function numericValidator(variant?: CmNumericValidatorVariation): ValidatorFn {
	return (control: AbstractControl) => {
		const value = control.value?.toString();
		if (!value)
			return null;

		const numeric = +value;

		if (isNaN(numeric))
			return { numeric: true };

		switch(variant) {
			case CmNumericValidatorVariation.Integer:
				return Number.isInteger(numeric) ? null : { numeric: true };
			case CmNumericValidatorVariation.Positive:
				return numeric > 0 ? null : { numeric: true };
			case CmNumericValidatorVariation.PositiveOrZero:
				return numeric >= 0 ? null : { numeric: true };
			case CmNumericValidatorVariation.Negative:
				return numeric < 0 ? null : { numeric: true };
			case CmNumericValidatorVariation.NegativeOrZero:
				return numeric <= 0 ? null : { numeric: true };
			default:
				return null;
		}
	};
}
